import Tabs from '@scripts/components/Tabs';
import Toggle from '@scripts/components/Toggle';
import CvRiskForm from '@scripts/forms/CvRiskForm';
import CvRiskHelpers from '@scripts/helpers';

/**
 * Front controller
 */
export default class {
  /**
   * Global CVRISK form
   *
   * @private
   *
   * @type {CvRiskForm}
   */
  #form;

  /**
   * Form tabs
   *
   * @private
   *
   * @type {Tabs}
   */
  #formTabs;

  /**
   * Validate a partial in tab
   *
   * @private
   *
   * @param {HTMLElement} tab Tab element
   *
   * @return {void}
   */
  #validate(tab) {
    if (this.#form.validatePartial(tab.dataset.partial)) {
      tab.classList.add('validated');
    } else {
      tab.classList.remove('validated');
    }
  }

  /**
   * Generate and download PDF after click on button
   *
   * @private
   *
   * @param {Event} e Click event
   *
   * @return {void}
   */
  #handlerBtnPdfClick(e) {
    e.preventDefault();
    this.#form.downloadPDF();
  }

  boot() {
    // check the required global variable
    if (!window?.CvRisk) {
      throw new Error('CvRisk Front: CvRisk is not defined');
    }

    this.#form = new CvRiskForm();
    this.#formTabs = new Tabs(this.#form.element, true);

    // Tooltip
    document.querySelectorAll('.cvrisk-tooltip').forEach((tooltip) => {
      tooltip.addEventListener('click', (e) => {
        e.preventDefault();

        let text = e.currentTarget.querySelector('.cvrisk-tooltip-content');
        if (text) {
          this.#form.openPopin(CvRiskHelpers.buildPopinContent(text.innerHTML));
        }
      });
    });

    // Toggle partials
    if (this.#formTabs.tabs) {
      // Validate a partial when closing the tab
      this.#formTabs.tabs.forEach((tab) =>
        tab.addEventListener('closed', () => this.#validate(tab))
      );

      // if form has been submitted, valdiate all tabs
      if (this.#form.element.classList.contains('is-autocompleted')) {
        this.#formTabs.tabs.forEach((tab) => this.#validate(tab));
      }
    }

    // Toggle
    this.#form.element
      .querySelectorAll('.cvrisk-toggle-trigger')
      .forEach((elt) => new Toggle(elt));

    // PDF
    document
      .querySelectorAll('.cvrisk-btn-pdf')
      .forEach((btn) =>
        btn.addEventListener('click', (e) => this.#handlerBtnPdfClick(e))
      );

    // Initialize form
    this.#form.initialize();
  }
}
